import { render, staticRenderFns } from "./Modal.Folder.Action.Rename.vue?vue&type=template&id=0ab8555e&scoped=true&"
import script from "./Modal.Folder.Action.Rename.vue?vue&type=script&lang=js&"
export * from "./Modal.Folder.Action.Rename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab8555e",
  null
  
)

export default component.exports